// Replace your existing JavaScript with this integrated version
// This combines your original mobile menu logic with the mega menu persistence

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  const nav = document.querySelector('#site-navigation');
  const accountControls = document.querySelector('.site-header__account-controls');
  const toggleButton = document.querySelector('.site-header__menu-toggle');
  const mainMenu = document.querySelector('#main-menu');
  const branding = document.querySelector('.site-header__branding');
  
  // Mega menu persistence variables
  let currentVisibleMegaMenu = null;
  let themeChangeTimeout = null;
  
  // Function to check if we're in mobile view
  const isMobile = () => window.innerWidth < 1024;

  // Function to switch to light theme
  const switchToLightTheme = () => {
    if (header.classList.contains('site-header--dark')) {
      header.classList.remove('site-header--dark');
      header.classList.add('site-header--light');
      header.setAttribute('data-original-theme', 'dark');
    }
    if (nav && nav.classList.contains('site-header--dark')) {
      nav.classList.remove('site-header--dark');
      nav.classList.add('site-header--light');
      nav.setAttribute('data-original-theme', 'dark');
    }
    if (accountControls && accountControls.classList.contains('site-header--dark')) {
      accountControls.classList.remove('site-header--dark');
      accountControls.classList.add('site-header--light');
      accountControls.setAttribute('data-original-theme', 'dark');
    }
  };
  
  // Function to restore original theme
  const restoreOriginalTheme = () => {
    if (header.hasAttribute('data-original-theme') && header.getAttribute('data-original-theme') === 'dark') {
      header.classList.remove('site-header--light');
      header.classList.add('site-header--dark');
      header.removeAttribute('data-original-theme');
    }
    if (nav && nav.hasAttribute('data-original-theme') && nav.getAttribute('data-original-theme') === 'dark') {
      nav.classList.remove('site-header--light');
      nav.classList.add('site-header--dark');
      nav.removeAttribute('data-original-theme');
    }
    if (accountControls && accountControls.hasAttribute('data-original-theme') && accountControls.getAttribute('data-original-theme') === 'dark') {
      accountControls.classList.remove('site-header--light');
      accountControls.classList.add('site-header--dark');
      accountControls.removeAttribute('data-original-theme');
    }
  };

  // Main menu toggle (your original code)
  if (toggleButton && mainMenu) {
    toggleButton.addEventListener('click', () => {
      // Check if the menu is open BEFORE toggling
      const menuIsOpen = mainMenu.classList.contains('is-open');

      // Handle theme switching for mobile BEFORE toggling classes
      if (isMobile()) {
        if (!menuIsOpen) {
          // Menu is about to open - switch to light
          switchToLightTheme();
        } else {
          // Menu is about to close - restore theme
          restoreOriginalTheme();
        }
      }

      // Toggle the "is-open" class for the menus and button
      mainMenu.classList.toggle('is-open', !menuIsOpen);
      toggleButton.classList.toggle('is-open', !menuIsOpen);
      document.body.classList.toggle('menu-is-open', !menuIsOpen);

      // If closing the menu, remove "is-open" from all menu items with mega menus
      if (menuIsOpen) {
        document.querySelectorAll('#main-menu .menu-item').forEach(item => {
          item.classList.remove('is-open');
        });
      }

      // Accessibility toggle attributes
      toggleButton.setAttribute('aria-expanded', String(!menuIsOpen));
      mainMenu.setAttribute('aria-hidden', String(menuIsOpen));
    });

    // Initialize ARIA attributes
    toggleButton.setAttribute('aria-expanded', 'false');
    mainMenu.setAttribute('aria-hidden', 'true');
  }

  // Desktop mega menu hover behavior (enhanced with persistence)
  const megaMenuItems = document.querySelectorAll('.has-mega-menu');
  
  megaMenuItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-menu');
    
    item.addEventListener('mouseenter', function() {
      if (!isMobile()) {
        // Clear any pending theme restore
        if (themeChangeTimeout) {
          clearTimeout(themeChangeTimeout);
          themeChangeTimeout = null;
        }
        
        // Hide any other visible mega menu
        if (currentVisibleMegaMenu && currentVisibleMegaMenu !== megaMenu) {
          currentVisibleMegaMenu.classList.remove('mega-menu--keep-visible');
        }
        
        // Show this mega menu and switch theme
        if (megaMenu) {
          megaMenu.classList.add('mega-menu--keep-visible');
          currentVisibleMegaMenu = megaMenu;
        }
        switchToLightTheme();
      }
    });
    
    item.addEventListener('mouseleave', function() {
      if (!isMobile()) {
        // Check if we should hide the mega menu
        setTimeout(() => {
          const isHoveringBranding = branding && branding.matches(':hover');
          const isHoveringAccountControls = accountControls && accountControls.matches(':hover');
          
          if (!isHoveringBranding && !isHoveringAccountControls) {
            if (currentVisibleMegaMenu === megaMenu) {
              if (megaMenu) {
                megaMenu.classList.remove('mega-menu--keep-visible');
              }
              currentVisibleMegaMenu = null;
              
              // Restore theme after a short delay
              themeChangeTimeout = setTimeout(() => {
                restoreOriginalTheme();
              }, 100);
            }
          }
        }, 50);
      }
    });
  });
  
  // Handle branding hover for mega menu persistence
  if (branding) {
    branding.addEventListener('mouseenter', function() {
      if (!isMobile()) {
        // Clear any pending theme restore
        if (themeChangeTimeout) {
          clearTimeout(themeChangeTimeout);
          themeChangeTimeout = null;
        }
      }
    });
    
    branding.addEventListener('mouseleave', function() {
      if (!isMobile()) {
        setTimeout(() => {
          if (currentVisibleMegaMenu) {
            const hoveredNavItem = Array.from(megaMenuItems).find(item => item.matches(':hover'));
            const isHoveringAccountControls = accountControls && accountControls.matches(':hover');
            
            if (!hoveredNavItem && !isHoveringAccountControls) {
              currentVisibleMegaMenu.classList.remove('mega-menu--keep-visible');
              currentVisibleMegaMenu = null;
              
              // Restore theme after a short delay
              themeChangeTimeout = setTimeout(() => {
                restoreOriginalTheme();
              }, 100);
            }
          }
        }, 100);
      }
    });
  }
  
  // Handle account controls hover for mega menu persistence
  if (accountControls) {
    accountControls.addEventListener('mouseenter', function() {
      if (!isMobile()) {
        // Clear any pending theme restore
        if (themeChangeTimeout) {
          clearTimeout(themeChangeTimeout);
          themeChangeTimeout = null;
        }
      }
    });
    
    accountControls.addEventListener('mouseleave', function() {
      if (!isMobile()) {
        setTimeout(() => {
          if (currentVisibleMegaMenu) {
            const hoveredNavItem = Array.from(megaMenuItems).find(item => item.matches(':hover'));
            const isHoveringBranding = branding && branding.matches(':hover');
            
            if (!hoveredNavItem && !isHoveringBranding) {
              currentVisibleMegaMenu.classList.remove('mega-menu--keep-visible');
              currentVisibleMegaMenu = null;
              
              // Restore theme after a short delay
              themeChangeTimeout = setTimeout(() => {
                restoreOriginalTheme();
              }, 100);
            }
          }
        }, 100);
      }
    });
  }

  // Mobile mega menu toggle - for items with children (your original code)
  const menuItems = document.querySelectorAll('#main-menu .menu-item.has-mega-menu > a');

  menuItems.forEach(link => {
    // Use click instead of touchstart for better compatibility
    link.addEventListener('click', (e) => {
      if (isMobile()) {
        const parent = link.closest('.menu-item');

        if (!parent.classList.contains('is-open')) {
          // First click: open mega menu and prevent navigation
          e.preventDefault();

          // Close other open mega menus
          document.querySelectorAll('#main-menu .menu-item.has-mega-menu.is-open').forEach(item => {
            if (item !== parent) {
              item.classList.remove('is-open');
            }
          });

          parent.classList.add('is-open');
        }
        // Second click: allow navigation (do not preventDefault)
      }
    });
  });

  // Breadcrumb behavior for mobile mega menu (your original code)
  const breadcrumbs = document.querySelectorAll('.mega-menu__breadcrumb');

  breadcrumbs.forEach(breadcrumb => {
    breadcrumb.addEventListener('click', (e) => {
      e.preventDefault();

      // Find any open mega menu item and close it
      const openItem = document.querySelector('#main-menu .menu-item.has-mega-menu.is-open');
      if (openItem) {
        openItem.classList.remove('is-open');
      }
    });
  });
});

// Add CSS for mega menu persistence and mobile scroll fixes
const style = document.createElement('style');
style.textContent = `
  @media (min-width: 1024px) {
    .mega-menu--keep-visible {
      visibility: visible !important;
      pointer-events: auto !important;
    }
    
    .mega-menu--keep-visible .mega-menu__inner {
      visibility: visible !important;
      clip-path: inset(0 0 0 0) !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      transition-delay: 0s, 0s, 0s !important;
    }
    
    /* Maintain curved background styling when mega menu is persistent */
    .has-mega-menu:has(.mega-menu--keep-visible) > a {
      position: relative;
      color: #345D64 !important; /* color(textBlue) */
      text-shadow: 0 0 0.5px #345D64;
      background-color: #f7f0eb !important; /* color(lightTan) */
    }
    
    /* Left curve - match your CSS positioning */
    .has-mega-menu:has(.mega-menu--keep-visible) > a::before {
      content: "";
      position: absolute;
      top: 0;
      left: -43.95px; /* Match your original CSS */
      width: 44.95px;
      height: 64.4px;
      background-color: #f7f0eb; /* color(lightTan) */
      mask-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 44.95 64.4'%3E%3Cg transform='scale(-1,1) translate(-44.95,0)'%3E%3Cpath fill='%23f7f0eb' class='cls-1' d='M0,64.4h44.95c-8.73,0-19.74-8.55-19.74-18.27v-25.2C25.21,10.85,13.75,0,3.1,0H0v64.4Z'/%3E%3C/g%3E%3C/svg%3E");
      mask-repeat: no-repeat;
      mask-position: bottom left;
    }
    
    /* Right curve - match your CSS positioning */
    .has-mega-menu:has(.mega-menu--keep-visible) > a::after {
      content: "";
      position: absolute;
      top: 0;
      right: -43.95px; /* Match your original CSS */
      width: 44.95px;
      height: 64.4px;
      background-color: #f7f0eb; /* color(lightTan) */
      mask-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 44.95 64.4'%3E%3Cpath fill='%23f7f0eb' class='cls-1' d='M0,64.4h44.95c-8.73,0-19.74-8.55-19.74-18.27v-25.2C25.21,10.85,13.75,0,3.1,0H0v64.4Z'/%3E%3C/svg%3E");
      mask-repeat: no-repeat;
      mask-position: bottom right;
    }
  }
  
  /* Mobile mega menu scroll fixes */
  @media (max-width: 1023px) {
    /* Fix the height calculation to match your CSS top: 93px */
    .has-mega-menu.is-open .mega-menu {
      top: 93px !important; /* Match your CSS */
      height: calc(100vh - 93px) !important; /* Fix calculation to match top value */
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important; /* Smooth iOS scrolling */
      position: fixed !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 9999 !important;
      background: white !important;
    }
    
    /* Remove conflicting overflow from inner elements */
    .has-mega-menu.is-open .mega-menu .mega-menu__inner {
      height: auto !important;
      overflow-y: visible !important; /* Remove competing scroll container */
      width: 100% !important;
    }
    
    /* Ensure content has proper padding for comfortable scrolling */
    .has-mega-menu.is-open .mega-menu .mega-menu__inner-content-container {
      padding-bottom: 60px !important; /* Extra space at bottom */
      min-height: calc(100vh - 93px - 60px) !important;
      padding-top: 32px !important;
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
    
    /* Prevent body scroll but allow touch events on mega menu */
    body.menu-is-open {
      position: fixed !important;
      width: 100% !important;
      height: 100% !important;
      overflow: hidden !important;
    }
    
    /* Ensure mega menu can receive touch events and scroll properly */
    body.menu-is-open .has-mega-menu.is-open .mega-menu {
      touch-action: pan-y !important; /* Allow vertical scrolling */
      overscroll-behavior: contain !important; /* Prevent scroll chaining */
    }
    
    /* Force hardware acceleration for smoother scrolling */
    .has-mega-menu.is-open .mega-menu {
      transform: translateZ(0) !important;
      will-change: scroll-position !important;
    }
  }
`;
document.head.appendChild(style);